import { React } from "react";
import { Card } from "antd";
import Slider from "react-slick";
import { Button } from "../../../components";
import { VscCalendar } from "react-icons/vsc";
import { AiOutlineClockCircle } from "react-icons/ai";
import { sliderSettingsNav  } from "../config";

const tabs = [
  {
    name: "All Leagues",
    active: true
  },
  {
    name: "Top Leagues",
    active: false
  },
  {
    name: "Women",
    active: false
  },
  {
    name: "Favorite",
    active: false
  },
  {
    name: "All Leagues",
    active: true
  },
  {
    name: "Top Leagues",
    active: false
  },
  {
    name: "Women",
    active: false
  },
  {
    name: "Favorite",
    active: false
  },
];

const CalendarBox = () => {
  return (
    <Card style={{padding: 20, borderRadius: 10}}>
      <Slider {...sliderSettingsNav }>
        <div></div>
        {tabs.map((item, index) => (
          <div key={index}>
            <Button
              type="primary"
              className={`mt-0 primary-color ${item.active ? "button-quad" : "button-transparent-quad"}`}
              title={item.name}
              style={{
                height: "50px",
                borderRadius: "30px",
                paddingLeft: "2.5em",
                paddingRight: "2.5em",
              }}
            />
          </div>
        ))}
      </Slider>
      <div className="flex mt-10 justify-between p-2 text-center">
        <div>
          <p><AiOutlineClockCircle /></p>
          <small>Live</small>
        </div>
        <div>
          <p>WED</p>
          <small>09 MAR</small>
        </div>
        <div>
          <p>THU</p>
          <small>09 MAR</small>
        </div>
        <div>
          <p>TODAY</p>
          <small>09 MAR</small>
        </div>
        <div>
          <p>SAT</p>
          <small>09 MAR</small>
        </div>
        <div>
          <p>SUN</p>
          <small>09 MAR</small>
        </div>
        <div>   
          <p><VscCalendar /></p>
          <small>DATE</small>
        </div>
      </div>
    </Card>
  );
};

export default CalendarBox;